<div class="title">
  {{ '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.OWNER_ADMINISTRATOR.HEADER' | translate }}
</div>

<div
  class="full-width flex flex-row lt-md:flex-col gap-[24px] xs:gap-[16px] justify-start items-start"
>
  <div class="lt-md:!hidden flex-[100%] max-w-[50%]"></div>

  <div class="full-width flex-1">
    <div class="radio-btns">
      <mat-radio-group
        class="flex flex-col"
        [disabled]="gatewayCommissioningStore.transferInstallationLoading$ | async"
      >
        <mat-radio-button
          gtm="onActivate"
          gtmAction="Commercial function"
          gtmCategory="gatewayCommissioning"
          class="radio-btn"
          data-at-are-you-owner="yes"
          [checked]="isOwnerOfTheInstallationSelected"
          [value]="true"
          (change)="onOwnerFunctionToggle(true)"
          >{{ 'GENERAL.BUTTON.YES' | translate }}
        </mat-radio-button>
        <mat-radio-button
          gtm="onActivate"
          gtmAction="Commercial function"
          gtmCategory="gatewayCommissioning"
          class="radio-btn"
          data-at-are-you-owner="no"
          [value]="false"
          [checked]="!isOwnerOfTheInstallationSelected"
          (change)="onOwnerFunctionToggle(false)"
          >{{ 'GENERAL.BUTTON.NO' | translate }}
        </mat-radio-button>
      </mat-radio-group>
    </div>

    <ng-container *ngIf="!isOwnerOfTheInstallationSelected">
      <form class="full-width" [formGroup]="emailFormGroup" data-at-provide-email>
        <div class="title">
          {{ '+GATEWAY_COMMISSIONING_REDESIGN.OWNER_EMAIL_ADDRESS.HEADER' | translate }}
        </div>
        <div class="sub-title">
          {{ '+GATEWAY_COMMISSIONING_REDESIGN.OWNER_EMAIL_ADDRESS.SUB_HEADER' | translate }}
        </div>
        <div class="flex flex-col justify-center items-center">
          <mat-form-field mat-input-height-large-label class="full-width">
            <mat-label>{{ '+PROFILE.DETAILS.EMAIL' | translate }}</mat-label>
            <input
              gtm="onTextField"
              gtmId="email"
              gtmAction="Email"
              gtmCategory="gatewayCommissioningEmailForm"
              [gtmOn]="['change', 'focus', 'blur']"
              type="email"
              name="email"
              matInput
              formControlName="email"
              data-end-user-email-input
              ngDefaultControl
            />
            <mat-error *ngIf="emailFormGroup.controls.email?.errors?.pattern"
              >{{ '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.EMAIL.ERROR.PATTERN' | translate }}
            </mat-error>
            <mat-error *ngIf="emailFormGroup.controls.email?.errors?.required"
              >{{ '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.EMAIL.ERROR.REQUIRED' | translate }}
            </mat-error>
            <mat-error *ngIf="emailFormGroup.controls.email?.errors?.forbiddenEmail"
              >{{
                '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.EMAIL.ERROR.FORBIDDEN_EMAIL_PROVIDED'
                  | translate
              }}
            </mat-error>
          </mat-form-field>
          <div class="mandatory-description">
            <sup>*</sup>
            {{ '+GATEWAY_COMMISSIONING.TRANSFER_INSTALLATION.MANDATORY_FIELDS' | translate }}
          </div>
        </div>
      </form>
    </ng-container>
  </div>
</div>
